import axios from './axiosDefaults'

export default {
  data: function() {
    return {
      loading: true,
      error: false,
      errorMessage: ''
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.error = false;
      return axios.get(this.jsonPath)
        .then(this.loadData)
        .then(() => { this.loading = false } )
        .catch(this.defaultErrorHandler);
    },
    loadData(response) {
      console.error('Override loadData method in component');
    },
    defaultErrorHandler(error) {
      console.log(error)
       if (error.response.status === 401) {
        location.reload() // Not authenticated. Reload page
       } else {
        this.loading = false;
        this.errorMessage = 'Sorry, something went wrong while loading the data. Please contact us if you continue to see this message.';
        this.error = true;
       }
    }
  }
}
